var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export var CustomIcon = styled(function (props) {
    return _jsx(FontAwesomeIcon, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var formatIconName = function (value) {
    var splittedValue = value.split(/(?=[A-Z])/);
    var iconType = splittedValue[0];
    var iconName = splittedValue.slice(1).join('-').toLowerCase();
    return [iconType, iconName];
};
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map